import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [ 'submit' ];

  validation = (e) => {
    this.submitTarget.disabled = !(e.target.files.length > 0);
  }
}
